import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-team-member-day-slot-card',
  templateUrl: './team-member-day-slot-card.component.html',
  styleUrls: ['./team-member-day-slot-card.component.scss']
})
export class TeamMemberDaySlotCardComponent implements OnInit {
  @Input() memberSchedules: any;
  @Input() isPastDate: any;
  @Output() addTimeOffEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() editSlotEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelLeaveEmiiter: EventEmitter<any> = new EventEmitter<any>();
  bgCardClass = '';

  constructor() { }

  ngOnInit(): void {
  }

  editSlot() {
    this.editSlotEmitter.emit(true);
  }

  addTimeOff() {
    this.addTimeOffEmitter.emit(true);
  }

  confirmCancelLeave() {
    this.cancelLeaveEmiiter.emit(true);
  }

}
